// Pure map from a /ogs list row → an assetRegistry card record. Split out (like
// ogsContentSelect.js) so it stays unit-testable under plain `node --test`,
// away from assetRegistry's CustomAssetManager import chain.
//
// /ogs is a loose-file collection keyed by bare filename (no DB id, no folders):
// the render bundle geom/appr/mesh/rig/manifest. rawId is the filename; delete
// is by filename. Returns null for a row with no filename (skip it).
export function ogsRecordFromRow(o) {
  const filename = o?.filename ?? o?.name
  if (!filename) return null
  return {
    id: `ogs:${filename}`,
    rawId: filename,
    kind: 'ogs',
    name: filename,
    url: o.fileUrl ?? o.file_url ?? null,
    byteSize: o.size ?? o.byte_size ?? null,
    serverFolderPath: '/ogs',
    raw: o,
  }
}
